import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db557cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedTabs, (tab, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.id
      }, [
        (_ctx.isAllowedChannel(tab.codeChannel))
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(_ctx.isActiveTab(tab) ? 'active' : ''),
              onClick: ($event: any) => (_ctx.handleTabChange(index))
            }, _toDisplayString(tab.name), 11, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}